/* Shared snap-rail controller for the results, social and electrode carousels.

   Scrolls by exactly one item so the snap points line up, dims an arrow once
   the rail reaches that end, and moves the progress dot.

   Markup contract — the root carries data-lv-rail-root, the arrows
   data-lv-rail-dir="-1|1", and the dot container data-lv-rail-marks. That
   keeps this file free of any one section's class names.

   data-lv-rail-trim on the dot container hides the marks past the last
   reachable scroll position, for rails that show several items at once and
   would otherwise display dots that can never light. Opt-in, because the
   source keeps a dot per card on some rails and trims on others.

   scrollLeft is negative in RTL in some engines, hence the Math.abs. */
window.lvRailInit = function (trackId, itemSelector) {
  var track = document.getElementById(trackId);
  if (!track || track.dataset.lvInit) return;
  track.dataset.lvInit = '1';

  var root = track.closest('[data-lv-rail-root]');
  if (!root) return;
  var marksBox = root.querySelector('[data-lv-rail-marks]');
  var marks = marksBox ? marksBox.querySelectorAll('span') : [];
  var trim = marksBox ? marksBox.hasAttribute('data-lv-rail-trim') : false;
  var btns = root.querySelectorAll('[data-lv-rail-dir]');

  function step() {
    var item = track.querySelector(itemSelector);
    if (!item) return track.clientWidth;
    var cs = getComputedStyle(track);
    var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function sync() {
    var max = track.scrollWidth - track.clientWidth - 2;
    var x = Math.abs(track.scrollLeft);
    var s = step();
    var i;
    for (i = 0; i < btns.length; i++) {
      var dir = Number(btns[i].getAttribute('data-lv-rail-dir'));
      btns[i].disabled = dir < 0 ? x <= 2 : x >= max;
    }
    var last = trim && s > 0 ? Math.ceil(max / s) : marks.length - 1;
    var at = Math.round(x / s);
    for (i = 0; i < marks.length; i++) {
      if (trim) {
        if (i > last) { marks[i].setAttribute('hidden', ''); } else { marks[i].removeAttribute('hidden'); }
      }
      marks[i].classList.toggle('is-on', i === at);
    }
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lv-rail-dir]');
    if (!b) return;
    var rtl = getComputedStyle(track).direction === 'rtl';
    var dir = Number(b.getAttribute('data-lv-rail-dir'));
    track.scrollLeft += step() * dir * (rtl ? -1 : 1);

    /* The scroll listener keeps the controls live while the user swipes, but it
       cannot be relied on here: a background tab suspends the rendering
       pipeline that dispatches scroll events, so a programmatic scroll there
       fires none at all. Resync directly, and once more after the smooth
       scroll has had time to land. */
    sync();
    setTimeout(sync, 400);
  });
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
};
